import React from 'react';
import {
  makeStyles,
  createStyles,
  Theme,
} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { baseTheme } from '../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      borderBottom: 'solid rgba(0, 0, 0, .2) 1px',
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
    featureText: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(1),
      fontSize: '1.5em',
      fontWeight: 'bold',
      textAlign: 'left',
    },
    icon: {
      height: '2.4em',
      marginTop: theme.spacing(2),
    },
  }),
);
export default function AvailableFeatureItem(props: any) {
  const { featureText } = props;
  const classes = useStyles(baseTheme);
  return (
    <Grid container item xs={12} className={classes.root}>
      <Grid item xs={8}>
        <Typography variant="h5" color="primary" className={classes.featureText}>
          {featureText}
        </Typography>
      </Grid>
      <Grid item xs={4} justify="center" alignItems="center">
        <img src="/images/checkmark.png" alt="Checkmark" className={classes.icon} />
      </Grid>
    </Grid>
  );
}
